import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@monksflow/monks-ui';
import { ChevronRightIcon } from 'lucide-react';
import type { ToolStepEvent } from '@/entities/ai';
import { AgentTask } from '../AgentTask';
import { TASK_ICON_CLASSES } from '../TaskItem/TaskItem.styles';

/**
 * The tool steps a reply took, kept under it once the answer is in: one closed row that counts
 * them and opens onto the same tree the reply showed while it worked.
 */
export const AgentTaskRecord = memo(
  ({ steps, settled = false }: { steps: ToolStepEvent[]; settled?: boolean }) => {
    const { t } = useTranslation('chats');
    if (steps.length === 0) return null;

    return (
      <Collapsible data-testid="agent-task-record" className="mb-xs">
        {/* The chevron sits in a step's icon box with a step's gap, so it and the label line up with
          the rows it opens. */}
        <CollapsibleTrigger className="group flex items-center gap-xs text-sm leading-5 text-muted-foreground transition-colors duration-fast ease-out hover:text-foreground">
          <span className={TASK_ICON_CLASSES}>
            <ChevronRightIcon
              aria-hidden
              className="size-4 transition-transform duration-fast ease-out group-data-[state=open]:rotate-90"
            />
          </span>
          {t('chats.agentTaskRecord.usedTools', { count: steps.length })}
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="pt-2xs">
            <AgentTask events={steps} live={false} settled={settled} />
          </div>
        </CollapsibleContent>
      </Collapsible>
    );
  },
);

AgentTaskRecord.displayName = 'AgentTaskRecord';
